import { createSelector } from 'reselect';

const selectDomain = (state) => state.coins;

export const selectTossing = createSelector([selectDomain], (state) => state.get('tossing'));

export const selectSeenFlipVersion = createSelector([selectDomain], (state) => state.get('seenVersion'));
